<template>
  <div class="main container-fluid faq-page">
    <header class="faq-hero">
      <div>
        <h4 class="faq-hero__title mb-1">Справочник</h4>
        <p class="faq-hero__subtitle mb-0">Раздел в разработке</p>
      </div>
    </header>

    <section class="px-3 pb-4">
      <div class="faq-surface">
        <div class="faq-surface__head">
          <span class="faq-surface__title">Скоро</span>
        </div>

        <div class="faq-placeholder">
          <div class="faq-placeholder__icon">
            <i class="lni lni-information"></i>
          </div>

          <h5 class="faq-placeholder__title mb-2">Справочник готовится</h5>
          <p class="faq-placeholder__text mb-0">
            Здесь появятся инструкции по работе с дашбордом, стримами, инструментами и credential.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'FaqPage',
}
</script>

<style scoped>
.faq-page {
  min-height: 100%;
  padding-top: 10px;
  background:
    radial-gradient(circle at 2% 3%, rgba(66, 153, 225, 0.2), transparent 36%),
    radial-gradient(circle at 98% 2%, rgba(56, 189, 248, 0.18), transparent 32%),
    #f3f7ff;
}

.faq-hero {
  margin: 0 20px 12px;
  padding: 14px 16px;
  border-radius: 16px;
  background: linear-gradient(135deg, #10305f 0%, #1b4f93 60%, #1e67b7 100%);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 18px 40px rgba(16, 48, 95, 0.22);
}

.faq-hero__title {
  font-weight: 800;
  letter-spacing: 0.01em;
}

.faq-hero__subtitle {
  color: rgba(232, 242, 255, 0.92);
  font-size: 13px;
}

.faq-surface {
  border-radius: 14px;
  border: 1px solid #dce7fa;
  background: #fff;
  padding: 12px;
  box-shadow: 0 8px 20px rgba(24, 55, 100, 0.08);
}

.faq-surface__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.faq-surface__title {
  display: inline-flex;
  align-items: center;
  padding: 5px 9px;
  border-radius: 999px;
  border: 1px solid #d8e5fb;
  background: #eff5ff;
  color: #3b5690;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.faq-placeholder {
  min-height: min(56vh, 420px);
  border: 1px dashed #c9d9f4;
  border-radius: 12px;
  background: linear-gradient(180deg, #fafdff 0%, #f4f8ff 100%);
  display: grid;
  place-content: center;
  text-align: center;
  padding: 24px 18px;
}

.faq-placeholder__icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 12px;
  border-radius: 14px;
  border: 1px solid #d6e5fb;
  background: #ecf4ff;
  color: #3e6ea8;
  font-size: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.faq-placeholder__title {
  color: #1f2d45;
  font-weight: 700;
}

.faq-placeholder__text {
  max-width: 540px;
  color: #607392;
  font-size: 14px;
  line-height: 1.45;
}

@media (max-width: 992px) {
  .faq-hero {
    margin: 0 12px 12px;
    padding: 12px;
  }

  .faq-placeholder {
    min-height: min(52vh, 380px);
  }
}
</style>
